import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="minimum_stay"
export default class extends Controller {
  static targets = ["checkbox", "overrideFields", "approvedById"]

  connect() {
    console.log('MinimumStay controller connected')
    console.log('Available targets:', this.targets)
    console.log('Checkbox targets found:', this.element.querySelectorAll('[data-minimum_stay-target="checkbox"]'))
    
    // Use direct selector as fallback
    this.checkbox = this.element.querySelector('#reservation_override_minimum_stay')
    this.overrideFields = this.element.querySelector('[data-minimum_stay-target="overrideFields"]')
    
    console.log('Direct checkbox found:', this.checkbox)
    console.log('Direct override fields found:', this.overrideFields)
    
    this.updateVisibility()
  }

  toggleOverrideFields() {
    this.updateVisibility()
  }

  toggleSelfApproval(event) {
    if (event.target.checked) {
      // Set the approved_by_id to the current user's ID
      if (this.hasApprovedByIdTarget) {
        this.approvedByIdTarget.value = this.currentUserId
      }
    } else {
      // Clear the approved_by_id
      if (this.hasApprovedByIdTarget) {
        this.approvedByIdTarget.value = ""
      }
    }
  }

  updateVisibility() {
    // Try Stimulus targets first, fallback to direct selectors
    const checkbox = this.hasCheckboxTarget ? this.checkboxTarget : this.checkbox
    const overrideFields = this.hasOverrideFieldsTarget ? this.overrideFieldsTarget : this.overrideFields
    
    if (checkbox && overrideFields) {
      if (checkbox.checked) {
        overrideFields.classList.remove("hidden")
        console.log('Override fields shown')
      } else {
        overrideFields.classList.add("hidden")
        console.log('Override fields hidden')
      }
    } else {
      console.error('Missing elements:', {
        checkbox: !!checkbox,
        overrideFields: !!overrideFields,
        hasCheckboxTarget: this.hasCheckboxTarget,
        hasOverrideFieldsTarget: this.hasOverrideFieldsTarget
      })
    }
  }

  get currentUserId() {
    return document.querySelector("meta[name='current-user-id']")?.content || ""
  }
}
